// eslint-disable-next-line no-unused-vars
import http from '@/core/http'
import { size } from 'lodash'

const url = 'taxa-conversao'

const state = {
  itens: [],
  explains: [],
  totalItens: 0
}

const actions = {
  getItens: async ({ commit }, payload) => {
    if (!payload) payload = {}

    const result = await http.get(url, { params: payload })
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },
  clearExplains: ({ commit }) => {
    commit('CLEAR_EXPLAINS')
  }
}

const mutations = {
  'LISTA_ITENS' (state, payload) {
    if (payload.resultExplain) {
      state.explains = payload.resultExplain
    } else {
      state.itens = payload.resultMap
      state.totalItens = size(payload.resultMap) > 0 ? payload.resultMap[0].count : 0
    }
  },
  'CLEAR_EXPLAINS' (state) {
    state.explains = []
  }
}

const getters = {
  listaItens: (state) => state.itens,
  listaExplains: (state) => state.explains,
  totalItens: (state) => state.totalItens,
}

export default { namespaced: true, state, actions, mutations, getters }
